import { render } from "./EmdFooter.vue?vue&type=template&id=6df7b98c&scoped=true"
import script from "./EmdFooter.vue?vue&type=script&lang=js"
export * from "./EmdFooter.vue?vue&type=script&lang=js"

import "./EmdFooter.vue?vue&type=style&index=0&id=6df7b98c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./EmdFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df7b98c"]])

export default __exports__